import { Box, Button } from "@mui/material";
// import { useState } from "react";
import { LoadingButton } from "src/shared/components";

interface IContractDialogFooterProps {
  isEdit?: boolean;
  isLoading: boolean;
  isFileExportLoading?: boolean;
  onSubmit: () => void;
  onCancel: () => void;
  onExport?: () => void;
  onPrint?: () => void;
}
export function ComplexContractDialogFooter({
  isEdit,
  isLoading,
  onSubmit,
  onCancel,
  onExport,
  onPrint,
  isFileExportLoading,
}: IContractDialogFooterProps) {
  // const [isContractChecked, setIsContractChecked] = useState(false);
  // const [isAttachmentChecked, setIsAttachmentChecked] = useState(false);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        flexDirection: { xs: "column", lg: "row" },
        gap: 4,
      }}
    >
      {onExport && onPrint && (
        <Box
          sx={{
            alignItems: { xs: "flex-start", md: "unset" },
            display: "flex",
            gap: 2,
            flexDirection: { xs: "column-reverse", md: "row" },
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: 2,
            }}
          >
            <LoadingButton
              onClick={onExport}
              variant="outlined"
              disabled={!isEdit || isFileExportLoading}
            >
              Экспортировать
            </LoadingButton>
            <LoadingButton variant="outlined" onClick={onPrint}>
              Печать
            </LoadingButton>
          </Box>
          {/* <FormControlLabel
            control={
              <Switch
                checked={isContractChecked}
                onChange={(e) => setIsContractChecked(e.target.checked)}
              />
            }
            label="Договор"
            labelPlacement="end"
          />
          <FormControlLabel
            control={
              <Switch
                checked={isAttachmentChecked}
                onChange={(e) => setIsAttachmentChecked(e.target.checked)}
              />
            }
            label="Прил-е №1"
            labelPlacement="end"
          /> */}
        </Box>
      )}
      <Box
        sx={{
          display: "flex",
          gap: 2,
          ml: "auto",
          justifyContent: { xs: "flex-end", lg: "unset" },
        }}
      >
        <LoadingButton
          isLoading={isLoading}
          variant="contained"
          onClick={onSubmit}
          disabled={isLoading}
        >
          {`Сохранить${isEdit ? " изменения" : ""}`}
        </LoadingButton>
        <Button variant="outlined" onClick={onCancel}>
          Закрыть
        </Button>
      </Box>
    </Box>
  );
}
